import type { ApplyAskPlanMove, AskPlanMove, KarlAskPlanMove } from "./types";

export const askPlanMove: AskPlanMove = (ask) => {
  const focus = ask?.focus;
  if (!focus) return { focusCircuit: null, highlight: null, trayType: null };

  const move: KarlAskPlanMove = {
    focusCircuit: focus.circuitId ?? null,
    // A pulse on one of several points points at the wrong thing, so a spread
    // of positions is framed and left unpulsed.
    highlight: focus.position ?? null,
    trayType: focus.trayType ?? null,
  };

  if (focus.position) move.zoomTo = focus.position;
  else if (focus.positions?.length) move.zoomToAll = focus.positions;

  return move;
};

export const applyAskPlanMove: ApplyAskPlanMove = ({ plan, move }) => {
  if (!plan) return;
  plan.focusCircuit(move.focusCircuit);
  plan.highlightTrayType?.(move.trayType);
  if (move.zoomTo) plan.zoomTo(move.zoomTo);
  else if (move.zoomToAll) plan.zoomToAll(move.zoomToAll);
  // Last, so the ring lands on a viewport that has already moved.
  plan.highlight(move.highlight);
};
